<script setup lang="ts">
const { currentStep, data, steps } = useMultiStepForm()

const visibleSteps = computed(() => {
  const packageData = data.value.package

  return steps.value.slice(1, -1).filter((step) => {
    if ('condition' in step) return step.condition(packageData)

    return true
  })
})

const currentStepData = computed(() => {
  return steps.value[currentStep.value]
})
</script>

<template>
  <div
    class="mb-8 grid items-center gap-4 md:gap-8 lg:mb-20 lg:grid-cols-[1fr_auto_1fr]"
    v-if="currentStep"
  >
    <h2
      class="text-center text-xl font-bold capitalize md:text-start md:text-3xl"
    >
      {{ currentStepData.meta.title }}
    </h2>
    <div class="flex justify-center">
      <div class="inline-flex items-center">
        <template :key="index" v-for="(step, index) in visibleSteps">
          <div
            :class="{
              'bg-white': Number(step.id) !== currentStep,
              'bg-black': Number(step.id) === currentStep,
            }"
            :id="step.id"
            class="h-1 w-12 md:w-20"
            v-if="index > 0"
          ></div>
          <div class="relative">
            <div
              :class="{
                'border-black bg-black text-sunglow-500 shadow-md':
                  Number(step.id) === currentStep,
                'bg-white text-black': Number(step.id) < currentStep,
                'border-white': Number(step.id) !== currentStep,
                'text-white': Number(step.id) > currentStep,
              }"
              class="grid h-12 w-12 place-items-center rounded-full border-2 text-xl font-bold md:h-16 md:w-16 md:text-3xl lg:h-20 lg:w-20"
            >
              {{ index + 1 }}
            </div>
            <div
              :class="{
                'text-black': Number(step.id) === currentStep,
                'text-white': Number(step.id) !== currentStep,
              }"
              class="absolute left-1/2 mt-2 hidden -translate-x-1/2 whitespace-nowrap text-center text-sm font-semibold md:block md:text-base"
            >
              <span>{{ step.meta.title }}</span>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
